import { gql } from '@apollo/client';

export const REMOVE_COACH_FROM_ATHLETE = gql`
  mutation RemoveCoachFromAthlete($coachId: ID!) {
    removeCoachFromAthlete(coachId: $coachId)
  }
`;

export const UPDATE_ATHLETE_PROFILE = gql`
  mutation UpdateAthleteProfile($firstName: String!, $lastName: String!, $sports: [String!]!) {
    updateAthleteProfile(firstName: $firstName, lastName: $lastName, sports: $sports) {
      _id
      firstName
      lastName
      sports
    }
  }
`;